// ANCHOR React
import { useState } from 'react';

// ANCHOR Model
import createModel from '@lxsmnsyc/react-scoped-model';

interface IProps {
  prompt: string;
  contentType: string;
  loading?: boolean;
  description?: string;
  callback?: () => any;
  asyncCallback?: () => Promise<any>;
  isStrict: boolean;
  cancelLabel?: string;
  confirmLabel?: string;
}

export const ConfirmationModalLogic = createModel(({
  prompt,
  callback,
  asyncCallback,
  loading,
  contentType,
  description,
  isStrict,
  cancelLabel,
  confirmLabel,
}: IProps) => {
  const [input, setInput] = useState('');

  return {
    state: {
      input,
      prompt,
      loading,
      contentType,
      description,
      callback,
      asyncCallback,
      isStrict,
      cancelLabel,
      confirmLabel,
    },
    handler: {
      input: setInput,
    },
    check: {
      allow: !isStrict || input === prompt,
    },
  };
},
  {
    displayName: 'Models.ConfirmationModalLogic',
  });
